export const designTokens = {
  color: {
    slate: {
      50: '#f8fafc',
      100: '#f1f5f9',
      200: '#e2e8f0',
      300: '#cbd5e1',
      400: '#94a3b8',
      500: '#64748b',
      600: '#475569',
      700: '#334155',
      800: '#1e293b',
      900: '#0f172a',
    },
    semantic: {
      bg: '#f7fcff',
      surface: '#ffffff',
      surfaceMuted: '#E5F7FC',
      border: '#cdeaf4',
      borderStrong: '#9ed8eb',
      text: '#0f172a',
      textMuted: '#53677d',
      textSubtle: '#7b91a8',
      primary: '#006DB0',
      primaryHover: '#00598f',
      primaryActive: '#004b78',
      primarySoft: '#E5F7FC',
      accent: '#00ACE6',
      accentSoft: '#d8f5ff',
      warm: '#FC8A33',
      warmSoft: '#fff0e6',
      focusRing: '#00ACE6',
      success: '#059669',
      warning: '#FC8A33',
      danger: '#dc2626',
      info: '#00ACE6',
    },
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    '2xl': '3rem',
    '3xl': '4rem',
  },
  radius: {
    sm: '0.375rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem',
  },
  typography: {
    display: {
      size: '28px',
      lineHeight: '36px',
      fontWeight: 700,
      family: "'Manrope', system-ui, sans-serif",
    },
    h1: {
      size: '24px',
      lineHeight: '32px',
      fontWeight: 700,
      family: "'Manrope', system-ui, sans-serif",
    },
    h2: {
      size: '20px',
      lineHeight: '28px',
      fontWeight: 700,
      family: "'Manrope', system-ui, sans-serif",
    },
    h3: {
      size: '18px',
      lineHeight: '26px',
      fontWeight: 700,
      family: "'Manrope', system-ui, sans-serif",
    },
    body: {
      size: '14px',
      lineHeight: '20px',
      fontWeight: 500,
      family: "'Manrope', system-ui, sans-serif",
    },
    small: {
      size: '12px',
      lineHeight: '16px',
      fontWeight: 500,
      family: "'Manrope', system-ui, sans-serif",
    },
    code: {
      size: '13px',
      lineHeight: '20px',
      fontWeight: 500,
      family: "'JetBrains Mono', monospace",
    },
  },
  shadow: {
    sm: '0 1px 2px 0 rgba(15, 23, 42, 0.05)',
    md: '0 4px 6px -1px rgba(15, 23, 42, 0.1), 0 2px 4px -2px rgba(15, 23, 42, 0.1)',
    lg: '0 10px 15px -3px rgba(15, 23, 42, 0.1), 0 4px 6px -4px rgba(15, 23, 42, 0.1)',
  },
  density: {
    controlHeight: '34px',
    controlHeightSmall: '30px',
    controlHeightLarge: '38px',
    inputPaddingX: '10px',
    inputPaddingY: '6px',
  },
} as const;
